import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { db, doc, getDoc } from '../services/firebase';

const ContactInformation = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      setError('');
      try {
        const docRef = doc(db, 'admin', 'legalPagesContent');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data().contact) {
          setContent(docSnap.data().contact);
        } else {
          setContent('No Contact Information content set by admin yet.');
        }
      } catch (err) {
        setError('Failed to load Contact Information.');
      }
      setLoading(false);
    };
    fetchContent();
  }, []);

  return (
    <div className="grey-bg-background">
      <Header />
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '80px 20px 60px',
        fontFamily: 'Inter, Arial, sans-serif'
      }}>
        <div style={{
          background: '#ffffff',
          borderRadius: '0',
          padding: '60px 80px',
          marginBottom: '40px',
          boxShadow: 'none',
          border: 'none'
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '50px',
            borderBottom: '1px solid #eaeaea',
            paddingBottom: '30px'
          }}>
            <h1 style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontWeight: '800',
              fontSize: '42px',
              margin: '0',
              color: '#222',
              letterSpacing: '-0.5px',
              lineHeight: '1.2'
            }}>
              Contact Information
            </h1>
            <p style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: '18px',
              color: '#666',
              margin: '16px 0 0 0',
              fontWeight: '400'
            }}>
              Last updated: {new Date().toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </p>
          </div>

          {loading ? (
            <div style={{
              textAlign: 'center',
              padding: '60px 0',
              color: '#888',
              fontSize: '18px',
              fontFamily: 'Inter, Arial, sans-serif'
            }}>
              Loading...
            </div>
          ) : error ? (
            <div style={{
              textAlign: 'center',
              padding: '60px 0',
              color: '#e74c3c',
              fontSize: '18px',
              fontFamily: 'Inter, Arial, sans-serif',
              background: '#fdf2f2',
              borderRadius: '8px',
              border: '1px solid #fecaca'
            }}>
              {error}
            </div>
          ) : (
            <div style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: '16px',
              color: '#333',
              lineHeight: '1.7',
              whiteSpace: 'pre-line',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              {content || (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 0',
                  color: '#888',
                  fontStyle: 'italic'
                }}>
                  No Contact Information content available yet. Please contact our administrator to add content.
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Mobile Responsive Styles */}
      <style>{`
        @media (max-width: 700px) {
          .grey-bg-background > div {
            padding: 40px 16px 40px !important;
          }
          .grey-bg-background > div > div {
            padding: 40px 24px !important;
            border-radius: 0 !important;
          }
          .grey-bg-background h1 {
            font-size: 32px !important;
            margin-bottom: 16px !important;
          }
          .grey-bg-background p {
            font-size: 16px !important;
          }
          .grey-bg-background > div > div > div:last-child {
            font-size: 15px !important;
            line-height: 1.6 !important;
          }
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default ContactInformation; 